import React, { useState } from 'react'
import { Container, Row, Col, Button, Form, Spinner } from 'react-bootstrap'
import { Product } from '../types';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, EyeIcon } from '@heroicons/react/24/outline';
import { useCartActions } from '../hooks/use-cart-actions';
import { AppModal } from '../components/modal';
import SingleProduct from './single-product';
import { useCart } from '../context/cart-context';
import { useProducts } from '../hooks/use-products';
import { PlaceholderLoader } from '../components/placeholder';
import { usePricingModel } from '../hooks/use-pricing-model';
import { useAuth } from '../context/auth-context'
import { thousandSeparator } from '../helper/utils';

const Shop = () => {

    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    const [selectedProduct, setSelectedProduct] = useState<Product|null>(null);
    const { products, loading } = useProducts();
    const { isAuth } = useAuth();

    const { handleAddToCart } = useCartActions();
    const { cartItems } = useCart();

    const handleModal = () => setIsShowModal(!isShowModal);
    const { renderProductPricingModelJSON } = usePricingModel();
    
    return (
        <section id="shop">
            <Container fluid>
                <Row className="bg-light justify-content-start mb-5">
                    <h1 className="section-title mt-4 mb-2 fs-2" data-aos="fade-up">SHOP</h1>
                    <span style={{fontSize: '.8rem'}} className='mb-4'>
                        {
                            isAuth ? (
                                <>
                                    <Link to="/customer/dashboard" className='text-success'>Dashboard</Link> 
                                    <ChevronRightIcon width={12} height={12} className='text-success' /> 
                                </>
                            ): (
                                <>
                                    <Link to="/" className='text-success'>Home</Link> 
                                    <ChevronRightIcon width={12} height={12} className='text-success' /> 
                                </>
                            )
                        }
                        <small>Shop</small>
                    </span>
                </Row>
                <Row>
                    {/* Filter Column */}
                    <Col md={3} className="position-sticky bg-white" style={{ 
                        zIndex: 9, 
                        height: 'fit-content', 
                        boxShadow: '-12px 23px 23px #16141429', 
                        top: '74px',
                        marginBottom: '70px',
                    }}>
                        <div className="p-3">
                            <h5>Filters</h5>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Category</Form.Label>
                                    <Form.Select>
                                    <option>All</option>
                                    <option>OBÈ Sauce</option>
                                    <option>Pepper Oil</option>
                                    <option>Smoky Jollof</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Price Range</Form.Label>
                                    <Form.Select>
                                    <option>50,000 - 100,000</option>
                                    <option>25,000 - 50,000</option>
                                    <option>18,0000 - 25,000</option>
                                    </Form.Select>
                                </Form.Group>

                                <Button variant="primary" type="submit">
                                    Apply Filters
                                </Button>
                            </Form>
                        </div>
                    </Col>

                    {/* Product Grid Column */}
                    <Col md={9}>
                        <Row className="p-3 pb-5 g-4 open-up" data-aos="zoom-out">
                            {loading ? 
                                [1,2,3,4,5,6,7,8,9,10,11,12].map(e => <div className='col-lg-3'><PlaceholderLoader /></div>) : 
                                products.map(product => {
                                const { price, priceString, strikeThroughPriceString, discountOff } = renderProductPricingModelJSON(product);
                                const newProduct = { ...product, productImages: [], inventories: [], price, priceString, strikeThroughPriceString: strikeThroughPriceString, discountOff }
                                return (
                                    <Col xs={12} sm={4} md={3} key={newProduct.id}>
                                        <div className="product-item image-zoom-effect link-effect">
                                            <div className="image-holder position-relative">
                                                <Link to={`#`} onClick={() => {
                                                    handleModal();
                                                    setSelectedProduct(newProduct);
                                                }}>
                                                    <img src={newProduct.image} height={200} alt={newProduct.name} className="product-image img-fluid" />
                                                </Link>
                                                <Link to={`#`} onClick={() => {
                                                    handleModal();
                                                    setSelectedProduct(newProduct);
                                                }} className="btn-icon btn-wishlist">
                                                    <EyeIcon width={23}  />
                                                </Link>
                                                <div className="product-content">
                                                    <h5 className="text-uppercase fs-6 mt-3">
                                                        <Link to={`#`}>{newProduct.name}</Link>
                                                    </h5>
                                                    {product.pouchesInCarton && product.productWeight && (
                                                        <section style={{
                                                            fontSize: '.8em',
                                                            color: '#000',
                                                            display: 'flex',
                                                            marginBottom: '.5rem',
                                                            flexFlow: 'row nowrap',
                                                            justifyContent: 'space-between'
                                                        }}>
                                                            <span className='m-0'>{ thousandSeparator(String(product.pouchesInCarton)) } {product.unit === 'ml' ? 'bottles' : 'pouches'} in carton</span>
                                                            <span 
                                                            className='m-0'
                                                            style={{
                                                                padding: '4px 10px',
                                                                borderRadius: '200px',
                                                                backgroundColor: '#3a974c1a',
                                                                fontSize: '.75em',
                                                                color: '#3A974C',
                                                                fontWeight: 700,
                                                            }}
                                                            >{ product.productWeight }{product.unit}</span>
                                                        </section>
                                                    )}
                                                    <Link to="#" onClick={() => handleAddToCart(newProduct)} className="fs-6 text-decoration-none" data-after="Add to cart">
                                                        <span>{priceString}</span>
                                                        {strikeThroughPriceString && (<span className="text-danger" style={{
                                                            textDecoration: 'line-through',
                                                            marginLeft: '5px',
                                                            fontSize: '.8rem'
                                                        }}>{  strikeThroughPriceString }</span>)}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </Col>
                </Row>
            </Container>
            <AppModal 
                isShowModal={isShowModal}
                handleCloseModal={handleModal}
                size='xl'
                children={
                    selectedProduct ? 
                    <SingleProduct product={selectedProduct} currentQty={cartItems.find(p => p.id === selectedProduct.id)?.quantity||1} /> : 
                    <Container className='d-flex flex-row justify-content-center align-item-center'><Spinner animation="border" variant='primary' /></Container>
                }
            />
        </section>
    )
}

export default Shop
